"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FIND = void 0;
const tab_1 = require("../../../tab");
exports.FIND = {
    description: 'Locate one text string within a second text string, and return the number of the starting position of the first text string from the first character of the second text string. Optionally, you can specify which occurrence you want to find.',
    arg_names: ['find_text', 'within_text', 'start_number'],
    args_def: [
        {
            types: ['string'],
            required: true,
        },
        {
            types: ['string'],
            required: true,
        },
        {
            types: ['number'],
            required: false,
        },
        {
            types: ['number'],
            required: false,
        },
    ],
    args_description: [
        'The text you want to find',
        'The text containing the text you want to find',
        'Specifies the character at which to start the search',
        'Specifies which text occurrence to locate you want to find. If omitted, the first occurrence will be returned',
    ],
    return_type: tab_1.ColumnType.NUMBER,
};
